import { useCypherpunk } from '../context/CypherpunkContext';
import { useScramble } from '../hooks/useScramble';

export function ScrambleText({ text, className = '', trigger = 'mount', as: Tag = 'span', 'data-testid': testId }) {
  const { cypherpunkMode } = useCypherpunk();
  const { displayed, handleHover } = useScramble(text, trigger, cypherpunkMode);

  return (
    <Tag
      className={className}
      onMouseEnter={handleHover}
      data-testid={testId}
    >
      {displayed || text}
    </Tag>
  );
}
